module.exports = __webpack_public_path__ + "static/img/celoscope-detail-20.9e12dff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-20.jpg
// module id = ZuNb
// module chunks = 51